import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { cloneDeep, get } from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  getOnboardingState,
  getEcapState,
  getAuthState,
} from '../../../store/selectors';
import { setActionPlan } from '../../../store/actions';
import GenericCareerCard from '../../utility/GenericCareerCard';
import Loading from '../../utility/Loading';
import HeaderWithHamburger from '../../utility/HeaderWithHamburger';
import CareerCardBottom from '../../utility/CareerCardBottom';
import ComponentHeader from '../ComponentHeader';
import NextButton from '../../utility/NextButton';
import ProgressCTA from '../../utility/ProgressCTA';
import { getHeaderListItems } from '../../utility/headerUtil';
import WindowTitle from '../../utility/WindowTitle';

function ActionPlan(props) {
  const { tenant } = { ...props };

  const [loading, setLoading] = useState(true);
  const [cardSelected, setCardSelected] = useState(null);

  const { t } = useTranslation();

  useEffect(() => {
    setLoading(false);
  }, [cardSelected]);

  const getTenantName = props.tenant.name;

  const onboarding = props.onboarding;

  const educationLevel = get(onboarding, 'userData.user.educationLevel');

  const getListItems = () => {
    return getHeaderListItems({
      educationLevel,
      tenantName: getTenantName,
    });
  };

  const getDegreeTitleEn = (careerId) => {
    return Object.values(props.onboarding.degreeChoices).filter((degree) => {
      return degree.id === careerId;
    });
  };

  const handleCardSelected = async (career) => {
    // If the card selected matches the one already highlighted, set it back to null
    if (cardSelected !== null && career.titleEn === cardSelected.titleEn)
      setCardSelected(null);
    else if (cardSelected === null || career.titleEn !== cardSelected.titleEn)
      setCardSelected(career);

    const actionPlan = cloneDeep(props.ecap.actionPlan);

    actionPlan.action_plan_career_id = career.id;
    await props.setActionPlan(actionPlan);
  };

  const getCareerCardWithBottom = () => {
    const actionPlanCards = Object.values(props.onboarding.careerChoices).map(
      (career) => {
        if (career.id && career.categoryImageUrl1) {
          const matchingDegree = getDegreeTitleEn(career.degreeId);

          if (matchingDegree[0]) {
            return (
              <div
                className="action-plan-card-with-bottom"
                key={career.id}
                onClick={() => handleCardSelected(career)}
                onKeyDown={() => handleCardSelected(career)}
                role="presentation"
              >
                <GenericCareerCard
                  img={career.image}
                  career={career}
                  overRideStyles="action-plan-card"
                  imageStyles="action-plan-card-image"
                  hideCareerContent
                  CareerContent={false}
                  favorite
                  tenant={props.tenant}
                  alert={false}
                />
                <CareerCardBottom
                  tenant={tenant}
                  careerTitleEn={career.titleEn}
                  degreeTitleEn={matchingDegree[0].titleEn}
                  staySelected={
                    cardSelected !== null &&
                    cardSelected.titleEn === career.titleEn
                  }
                />
              </div>
            );
          }
        }

        return null;
      }
    );

    return actionPlanCards;
  };

  return (
    <div id="action-plan">
      <WindowTitle>{t('Education and Career Action Plan')}</WindowTitle>
      {/* Is the user actively searching or should we display just the 3 sections? */}
      {loading ? (
        <Loading height="100%" />
      ) : (
        <>
          <HeaderWithHamburger
            tenant={tenant}
            linkToDashboard
            listItems={getListItems()}
          />
          <ComponentHeader
            tenant={tenant}
            headerText={t('Education Career Action Plan')}
            subheadingText={t(
              'Choose which Career You Wish To Create An Action Plan For'
            )}
            parent="action-plan"
          />
          <div className="action-plan-cards-container">
            {getCareerCardWithBottom()}
          </div>
          {cardSelected !== null ? (
            <>
              <ProgressCTA
                tenant={tenant}
                milestoneText={t('Great! Now let’s make a plan!')}
                overRideStyle="action-plan-milestone"
              />
              <NextButton
                color={tenant.primary}
                isActive={cardSelected !== null}
                overRideStyle="action-plan-next-button"
                nextPath={`/${tenant.name.toLowerCase()}/education-plan`}
              />
            </>
          ) : null}
        </>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);
  const ecap = getEcapState(state);

  return { onboarding, ecap, auth };
}

export default connect(mapStateToProps, { setActionPlan })(ActionPlan);
